export enum EstatusProyecto {
  CREADO = "Creado",
  EST_SOL_ODP = "Estimación Solicitada a ODP",
  EST_SOL_LID = "En Estimación por Líder",
  REV_ODP = "En Revisión ODP",
  REV_MARKETING = "En Revisión Marketing",
  CANCELADA = "Cancelada",
  EST_MARKETING = "En Estimación por Marketing",
  EST_CLIENTE = "Enviado al cliente",
}

export namespace EstatusProyecto {
  export function getName(value: EstatusProyecto): string {
    return Object.keys(EstatusProyecto).find(
      (key) => EstatusProyecto[key] === value
    );
  }

  export function getListEstatus(): Array<{ name: string; val: string }> {
    return Object.keys(EstatusProyecto)
      .filter((key) => typeof EstatusProyecto[key] !== "function")
      .map((key) => {
        return { name: key, val: EstatusProyecto[key] };
      });
  }
  export function getIcoEstatus(estatus: string): string {
    switch (estatus) {
      case "CREADO":
        return "menu_book";
      case "EST_SOL_ODP":
        return "find_in_page";
      case "EST_SOL_LID":
        return "event_note";
      case "REV_ODP":
        return "visibility";
      case "REV_MARKETING":
      case "EST_COMMERCIAL":
        return "edit_calendar";
      case "EST_CLIENTE":
        return "mark_email_read";
      case "EST_MARKETING":
        return "event_available";
      case "CANCELADA": // 👈 nuevo caso agregado
        return "cancel"; // ícono típico de Material Design
      default:
        return "info";
    }
  }
}
